module.exports = __webpack_public_path__ + "fonts/Flaticon.05e2d617.ttf";